import { get, post, del } from '../AxiosConfig';

const getProfitabilityReport = (payload) =>
  post('/profitability/monthly-report', payload);

const getSalaries = ({ companyId, month, year }) =>
  get(`/profitability/salary?companyId=${companyId}&month=${month}&year=${year}`);

const saveSalary = (payload) =>
  post('/profitability/salary', payload);

const getExpenses = ({ companyId, month, year, startYearMonth = null, endYearMonth = null }) => {
  let url = `/profitability/expenses?companyId=${companyId}&month=${month}&year=${year}`;
  if (startYearMonth != null) url += `&startYearMonth=${startYearMonth}`;
  if (endYearMonth   != null) url += `&endYearMonth=${endYearMonth}`;
  return get(url);
};

// saveExpense — כולל שדות חדשים: expenseSourceId, blobPath, originalFileName, fileSize, invoiceDate
const saveExpense = (payload) =>
  post('/profitability/expense', payload);

const getInvoices = ({ companyId, month = 0, year = 0, missingOnly = false, startYearMonth = null, endYearMonth = null }) => {
  let url = `/profitability/invoices?companyId=${companyId}&month=${month}&year=${year}&missingOnly=${missingOnly ? 1 : 0}`;
  if (startYearMonth != null) url += `&startYearMonth=${startYearMonth}`;
  if (endYearMonth   != null) url += `&endYearMonth=${endYearMonth}`;
  return get(url);
};

const saveInvoice = (payload) =>
  post('/profitability/invoice', payload);

const getLocationGroups = ({ companyId }) =>
  get(`/profitability/location-groups?companyId=${companyId}`);

const saveLocationGroup = (payload) =>
  post('/profitability/location-group', payload);

const getPaymentSchedule = ({ companyId, month, year }) =>
  get(`/profitability/payment-schedule?companyId=${companyId}&month=${month}&year=${year}`);

const rebuildMonthlyStats = (payload) =>
  post('/profitability/rebuild-monthly', payload);

const updateBankCashFee = (payload) =>
  post('/profitability/bank-cash-fee', payload);

const getTerminalsForAssignment = ({ companyId }) =>
  get(`/profitability/terminals-for-assignment?companyId=${companyId}`);

const assignGroupTerminals = (payload) =>
  post('/profitability/assign-group-terminals', payload);

// ── ספקי הוצאות ──────────────────────────────────────────────
const getExpenseSources = ({ companyId, includeInactive = false }) =>
  get(`/profitability/expense-sources?companyId=${companyId}&includeInactive=${includeInactive ? 1 : 0}`);

const saveExpenseSource = (payload) =>
  post('/profitability/expense-source', payload);

const getExpenseCategories = ({ companyId }) =>
  get(`/profitability/expense-categories?companyId=${companyId}`);

const getMissingFixedExpenses = ({ companyId, month, year }) =>
  get(`/profitability/expenses/missing-fixed?companyId=${companyId}&month=${month}&year=${year}`);

const uploadExpenseFile = ({ companyId, fileContent, fileName, year, month }) =>
  post('/profitability/expense/upload', { companyId, fileContent, fileName, year, month });

const getExpenseFileUrl = ({ id, companyId }) =>
  get(`/profitability/expense/${id}/url?companyId=${companyId}`);

// ── חשבוניות סרוקות ──────────────────────────────────────────
const uploadInvoiceFile = (payload) =>
  post('/profitability/invoice/upload', payload);

const getInvoiceQueue = ({ companyId }) =>
  get(`/profitability/invoice/queue?companyId=${companyId}`);

const assignInvoiceFile = (payload) =>
  post('/profitability/invoice/assign', payload);

const getInvoiceFileUrl = ({ id, companyId }) =>
  get(`/profitability/invoice/${id}/url?companyId=${companyId}`);

const deleteInvoiceQueueItem = ({ id, companyId }) =>
  del(`/profitability/invoice/queue/${id}?companyId=${companyId}`);

const assignInvoiceAsExpense = (payload) =>
  post('/profitability/invoice/assign-expense', payload);

const profitabilityService = {
  getProfitabilityReport,
  getSalaries,
  saveSalary,
  getExpenses,
  saveExpense,
  getExpenseSources,
  saveExpenseSource,
  getMissingFixedExpenses,
  uploadExpenseFile,
  getExpenseFileUrl,
  getInvoices,
  saveInvoice,
  getLocationGroups,
  saveLocationGroup,
  getPaymentSchedule,
  rebuildMonthlyStats,
  updateBankCashFee,
  getTerminalsForAssignment,
  assignGroupTerminals,
  uploadInvoiceFile,
  getInvoiceQueue,
  assignInvoiceFile,
  getInvoiceFileUrl,
  deleteInvoiceQueueItem,
  assignInvoiceAsExpense,
  getExpenseCategories,
};

export default profitabilityService;
